import { render, staticRenderFns } from "./PdfContent.vue?vue&type=template&id=461708b4&"
import script from "./PdfContent.vue?vue&type=script&lang=js&"
export * from "./PdfContent.vue?vue&type=script&lang=js&"
import style0 from "./PdfContent.vue?vue&type=style&index=0&id=461708b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports